import axios from "../api/axios";

export interface DashboardNotification {
  id: number;
  createdAt: string;
  type: number;
  text: string;
  isRead: boolean;
  name?: string;
}

// EventAction enum values
export enum NotificationEventAction {
  Unknown = 0,
  Login = 1,
  Logout = 2,
  Create = 3,
  Update = 4,
  Delete = 5,
  Archive = 6,
  Unarchive = 7,
  UserInvited = 20,
  UserActivated = 21,
  UserSuspended = 22,
  UserReactivated = 23,
  UserProfileEdited = 24,
  TwoFactorEnabled = 25,
  TwoFactorDisabled = 26,
  TreatmentPlanGenerated = 40,
  TreatmentPlanEdited = 41,
  TreatmentPlanApprovedProvider = 42,
  TreatmentPlanSentToPatient = 43,
  TreatmentPlanApprovedPatient = 44,
  TreatmentPlanRejectedPatient = 45,
  TreatmentPlanStatusUpdated = 46,
  AppointmentScheduled = 60,
  AppointmentRescheduled = 61,
  AppointmentCancelled = 62,
  AppointmentFileAttached = 63,
  OperatingHoursUpdated = 80,
  ProcedureDurationUpdated = 81,
  NotificationPreferencesChanged = 82,
}

export const dashboardService = {
  // Get notifications
  async getNotifications(): Promise<DashboardNotification[]> {
    const response = await axios.get<DashboardNotification[]>(
      "/notifications"
    );
    return response.data || [];
  },

  // Mark notifications as read
  async markNotificationsAsRead(ids: number[]): Promise<void> {
    await axios.post("/dashboard/notifications/read", {
      ids,
    });
  },
};
